import React, { useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useApp } from "../../Context/AppContext";
import manufacturer_default from "../../images/prodimages/manufacturer_default.svg";
/* ── Fallback SVG ── */
// const FallbackIcon = () => (
//   <svg
//     width="100%"
//     height="100%"
//     viewBox="0 0 120 120"
//     fill="none"
//     xmlns="http://www.w3.org/2000/svg"
//   >
//     <circle
//       cx="60"
//       cy="60"
//       r="52"
//       fill="#f4fbfa"
//       stroke="#d4ecea"
//       strokeWidth="1.5"
//     />
//     <rect
//       x="18"
//       y="47"
//       width="84"
//       height="26"
//       rx="13"
//       fill="#eaf4f3"
//       stroke="#c5d5d4"
//       strokeWidth="1.5"
//     />
//     <path
//       d="M18 60C18 52.8 23.8 47 31 47H60V73H31C23.8 73 18 67.2 18 60Z"
//       fill="#5fbdb3"
//       fillOpacity="0.55"
//     />
//     <path
//       d="M102 60C102 67.2 96.2 73 89 73H60V47H89C96.2 47 102 52.8 102 60Z"
//       fill="#cc4d17"
//       fillOpacity="0.50"
//     />
//     <line
//       x1="60"
//       y1="47"
//       x2="60"
//       y2="73"
//       stroke="white"
//       strokeWidth="1.5"
//       strokeDasharray="3 2.5"
//     />
//     <ellipse
//       cx="33"
//       cy="30"
//       rx="11"
//       ry="6.5"
//       fill="#eaf4f3"
//       stroke="#5fbdb3"
//       strokeWidth="1.5"
//     />
//     <ellipse
//       cx="87"
//       cy="91"
//       rx="11"
//       ry="6.5"
//       fill="#ffd5c2"
//       stroke="#cc4d17"
//       strokeWidth="1.5"
//     />
//     <rect
//       x="88"
//       y="23"
//       width="4"
//       height="16"
//       rx="2"
//       fill="#cc4d17"
//       fillOpacity="0.4"
//     />
//     <rect
//       x="82"
//       y="29"
//       width="16"
//       height="4"
//       rx="2"
//       fill="#cc4d17"
//       fillOpacity="0.4"
//     />
//     <rect
//       x="22"
//       y="81"
//       width="4"
//       height="16"
//       rx="2"
//       fill="#5fbdb3"
//       fillOpacity="0.45"
//     />
//     <rect
//       x="16"
//       y="87"
//       width="16"
//       height="4"
//       rx="2"
//       fill="#5fbdb3"
//       fillOpacity="0.45"
//     />
//   </svg>
// );
const FallbackIcon = () => (
  <img
    src={manufacturer_default}
    alt="default"
    className="w-full h-full object-contain"
  />
);
/* 4 rotating card themes */
const BRAND_THEMES = [
  {
    bg: "bg-gradient-to-b from-[#eaf4f3] to-white",
    border: "border-[#c5d5d4] hover:border-[#5fbdb3]",
    accent: "from-[#1e4a46] via-[#5fbdb3] to-[#1e4a46]",
    imgBg: "bg-[#f4fbfa]",
    name: "text-[#1e4a46] group-hover:text-[#3a7a74]",
    nameStrip: "bg-[#f4fbfa]/90 border-[#d4ecea]/60",
    shadow:
      "shadow-[0_2px_12px_rgba(95,189,179,0.10)] hover:shadow-[0_10px_28px_rgba(95,189,179,0.24)]",
    dot: "bg-[#5fbdb3]",
  },
  {
    bg: "bg-gradient-to-b from-[#fff3ee] to-white",
    border: "border-[#ffd5c2] hover:border-[#ff601e]",
    accent: "from-[#ff601e] via-[#ffd5c2] to-[#ff601e]",
    imgBg: "bg-[#fff8f5]",
    name: "text-[#c44a14] group-hover:text-[#ff601e]",
    nameStrip: "bg-[#fff8f5]/90 border-[#ffd5c2]/60",
    shadow:
      "shadow-[0_2px_12px_rgba(255,96,30,0.09)] hover:shadow-[0_10px_28px_rgba(255,96,30,0.24)]",
    dot: "bg-[#ff601e]",
  },
  {
    bg: "bg-gradient-to-b from-[#f4fbfa] to-white",
    border: "border-[#d4ecea] hover:border-[#3a7a74]",
    accent: "from-[#3a7a74] via-[#5fbdb3] to-[#3a7a74]",
    imgBg: "bg-[#eaf4f3]",
    name: "text-[#284b49] group-hover:text-[#1e4a46]",
    nameStrip: "bg-[#eaf4f3]/90 border-[#d4ecea]/60",
    shadow:
      "shadow-[0_2px_12px_rgba(58,122,116,0.09)] hover:shadow-[0_10px_28px_rgba(58,122,116,0.22)]",
    dot: "bg-[#5fbdb3]",
  },
  {
    bg: "bg-gradient-to-b from-[#fff8f0] to-white",
    border: "border-[#ffd5c2] hover:border-[#ff601e]/70",
    accent: "from-[#ff601e] to-[#e55519]",
    imgBg: "bg-[#fff3ee]",
    name: "text-[#c44a14] group-hover:text-[#ff601e]",
    nameStrip: "bg-[#fff3ee]/90 border-[#ffd5c2]/60",
    shadow:
      "shadow-[0_2px_12px_rgba(255,96,30,0.08)] hover:shadow-[0_10px_28px_rgba(255,96,30,0.22)]",
    dot: "bg-[#ff601e]",
  },
];

/* ── Single brand card ── */
const BrandCard = ({ brand, onClick, index }) => {
  const [imgError, setImgError] = useState(false);
  const hasImage = brand.image_url && !imgError;
  const t = BRAND_THEMES[index % BRAND_THEMES.length];

  return (
    <button
      onClick={onClick}
      className={`group flex-shrink-0 w-[140px] sm:w-[160px] lg:w-[180px] xl:w-[195px]
        border-[1.5px] ${t.border} ${t.bg} ${t.shadow}
        rounded-2xl overflow-hidden flex flex-col relative cursor-pointer
        hover:-translate-y-2 transition-all duration-300`}
    >
      {/* Top accent bar */}
      <div
        className={`absolute top-0 left-0 right-0 h-[3px] bg-gradient-to-r ${t.accent} opacity-0 group-hover:opacity-100 transition-opacity duration-300 z-10`}
      />

      {/* Corner dot */}
      <div
        className={`absolute top-2.5 right-2.5 w-2 h-2 rounded-full ${t.dot} opacity-20 group-hover:opacity-65 group-hover:scale-125 transition-all duration-300 z-10`}
      />

      {/* Image area */}
      <div
        className={`w-full h-[120px] sm:h-[140px] lg:h-[160px] ${t.imgBg} flex items-center justify-center  flex-shrink-0`}
      >
        {hasImage ? (
          <img
            src={brand.image_url}
            alt={brand.manufacturer_name || brand.name}
            onError={() => setImgError(true)}
            className="max-h-full max-w-full object-contain group-hover:scale-110 transition-transform duration-300"
          />
        ) : (
          <div className="pt-3">
            <FallbackIcon />
          </div>
        )}
      </div>

      <div className="w-full h-px bg-black/[0.05]" />

      {/* Name strip */}
      <div
        className={`px-3 py-2.5 flex items-center justify-between gap-2 border-t ${t.nameStrip}`}
      >
        <p
          className={`text-[11px] sm:text-[12px] font-semibold leading-snug line-clamp-1 flex-1 text-left transition-colors duration-200 ${t.name}`}
        >
          {brand.manufacturer_name || brand.name || "Brand"}
        </p>
        <svg
          width="10"
          height="10"
          viewBox="0 0 24 24"
          fill="none"
          stroke="#5fbdb3"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="flex-shrink-0 opacity-0 group-hover:opacity-100 -translate-x-1.5 group-hover:translate-x-0 transition-all duration-200"
        >
          <path d="M5 12h14M12 5l7 7-7 7" />
        </svg>
      </div>
    </button>
  );
};

/* ════════════════════════════════════════════════════════════ */
const ShopByBrand = () => {
  const { contextBrands } = useApp();
  const scrollRef = useRef(null);
  const navigate = useNavigate();

  /* ── KEY FIX: Navigate to /products with brand pre-selected ── */
  const handleClickForBrand = (manufacturer_id, name) => {
    navigate("/products", {
      state: {
        preselectedBrand: {
          id: manufacturer_id,
          name: name,
        },
      },
    });
  };

  const handleScroll = (dir) =>
    scrollRef.current?.scrollBy({
      left: dir === "left" ? -220 : 220,
      behavior: "smooth",
    });

  return (
    <section className="w-full py-8 sm:py-6 lg:py-6 px-4 sm:px-6 lg:px-6 xl:px-6 font-poppins bg-white">
      {/* Header */}
      <div className="flex items-end justify-between mb-6 sm:mb-8">
        <div>
          <div className="flex items-center gap-2 mb-1.5">
            <span className="w-5 h-[2px] bg-[#ff601e] rounded-full" />
            <span className="text-[10px] sm:text-[11px] font-bold uppercase tracking-widest text-[#ff601e]">
              Trusted Names
            </span>
          </div>
          <h2 className="font-bold text-[20px] sm:text-[24px] lg:text-[28px] text-[#1e4a46] leading-tight">
            Shop by Brands
          </h2>
          <p className="text-[13px] text-[#8faba9] mt-1 hidden sm:block">
            Browse medicines from your favourite pharmaceutical brands
          </p>
        </div>
        {/* View All → /products with no brand filter (shows all) */}
        <Link to="/shopbrand">
          <button className="flex items-center gap-1.5 bg-[#162c2a] hover:bg-[#ff601e] text-white font-semibold text-[11px] sm:text-[12px] px-4 h-8 rounded-xl transition-all duration-200 shadow-[0_2px_8px_rgba(22,44,42,0.25)] hover:shadow-[0_4px_14px_rgba(255,96,30,0.4)] hover:-translate-y-0.5 border-none cursor-pointer">
            View All
            <svg
              width="11"
              height="11"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M5 12h14M12 5l7 7-7 7" />
            </svg>
          </button>
        </Link>
      </div>

      {/* Carousel */}
      <div className="relative">
        {/* Left arrow */}
        <button
          onClick={() => handleScroll("left")}
          className="absolute -left-3 sm:-left-5 top-1/2 -translate-y-1/2 z-20 w-8 h-8 sm:w-10 sm:h-10 rounded-xl bg-white border-[1.5px] border-[#c8d8d7] shadow-[0_2px_10px_rgba(22,44,42,0.1)] flex items-center justify-center text-[#1e3330] hover:bg-[#ddf0ee] hover:border-[#5fbdb3] hover:text-[#1e4a46] transition-all duration-200 cursor-pointer"
        >
          <svg
            width="14"
            height="14"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M19 12H5M12 5l-7 7 7 7" />
          </svg>
        </button>

        {/* Scrollable row */}
        <div
          ref={scrollRef}
          className="flex gap-3 sm:gap-4 overflow-x-auto scrollbar-hide scroll-smooth px-1 py-3"
        >
          {contextBrands.map((brand, index) => (
            <BrandCard
              key={brand.manufacturer_id}
              brand={brand}
              index={index}
              onClick={() =>
                handleClickForBrand(
                  brand.manufacturer_id,
                  brand.manufacturer_name || brand.name,
                )
              }
            />
          ))}
        </div>

        {/* Right arrow */}
        <button
          onClick={() => handleScroll("right")}
          className="absolute -right-3 sm:-right-5 top-1/2 -translate-y-1/2 z-20 w-8 h-8 sm:w-10 sm:h-10 rounded-xl bg-white border-[1.5px] border-[#c8d8d7] shadow-[0_2px_10px_rgba(22,44,42,0.1)] flex items-center justify-center text-[#1e3330] hover:bg-[#ddf0ee] hover:border-[#5fbdb3] hover:text-[#1e4a46] transition-all duration-200 cursor-pointer"
        >
          <svg
            width="14"
            height="14"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M5 12h14M12 5l7 7-7 7" />
          </svg>
        </button>
      </div>

      <style>{`
        .scrollbar-hide::-webkit-scrollbar { display: none; }
        .scrollbar-hide { -ms-overflow-style: none; scrollbar-width: none; }
      `}</style>
    </section>
  );
};

export default ShopByBrand;
